import { useUserInfo } from '../../store/user'
import { useEffect } from 'react'
import * as Sentry from '@sentry/react'

export const useSentryIntegration = () => {
  const user = useUserInfo()

  useEffect(() => {
    if (window.appInsights && user.id) {
      window.appInsights.setAuthenticatedUserContext(user.id)
    }
    Sentry.setUser({ id: user.id, email: user.email })
  }, [user.id, user.email])
}
